import React, { useEffect } from 'react';
import { View } from 'react-native';
import { useAppSelector } from '../hooks';
import { themeMenuContent } from '../styles';
import { validateLogon } from '../utils/auth';
import { TreeNode, SideMenus } from '.';

type Props = {
  navigation: any;
  menuTitle?: string;
  menus: TreeNode[];
  requiredLogin?: boolean;
  children: React.ReactNode;
};

export const MenuContentTemplate = ({
  navigation,
  menuTitle = 'Menu',
  menus,
  requiredLogin = true,
  children,
}: Props) => {
  const [rtPortal, rtUser] = useAppSelector(s => [s.portal, s.user]);

  useEffect(() => {
    (async () => {
      if (requiredLogin && (await validateLogon(rtUser)) === false) {
        navigation.navigate('login');
      }
    })();
  }, []);

  return (
    <View style={rtPortal.isSmallScreen ? themeMenuContent.containerSM : themeMenuContent.container}>
      <SideMenus menus={menus} menuTitle={menuTitle} />
      <View style={themeMenuContent.contentContainer}>{children}</View>
    </View>
  );
};
